export const LocalesList = ["en", "es", "ru"] as const;

export type LocaleType = (typeof LocalesList)[number];

export type LocaleMap<T> = {
  [key in LocaleType]: T;
};

export const Locales = {
  EN: "en",
  ES: "es",
  RU: "ru",
} as const;
